import React from 'react'
import pallete from '../../../global/newPallete'

interface CardProps {
  children: React.ReactNode
  className?: string
}

const Card: React.FC<CardProps> = ({ children, className = '' }) => {
  return (
    <div
      className={`bg-white rounded-medium border  py-[16px] px-[20px] ${className}`}
      style={{ borderColor: pallete.colors.stroke5, borderRadius: '10px' }}
    >
      {children}
    </div>
  )
}

export default Card
